import { Types } from "../config";

export const normalizeLoginType = (loginType) => {
  if (loginType === "admin" || loginType === 1) return "admin";
  if (loginType === "user" || loginType === 3) return "user";
  if (typeof loginType === "string" && Types[loginType]) {
    return Types[loginType];
  }
  return null;
};

export const isAuthenticated = (user) => {
  return Boolean(user?.token && normalizeLoginType(user?.loginType));
};

export const clearPersistedAuth = () => {
  if (typeof window === "undefined") return;

  const keysToRemove = [
    "persist:local",
    "persist:session",
    "persist:language",
  ];

  keysToRemove.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};
